import React from 'react';
import '../App.css';
import './tool.css';
import { useAppSelector, useAppDispatch } from '../app/hooks';

// images
import spinnerDark from '../icons/spinner-dark.64.gif';
import spinnerLight from '../icons/spinner-light.64.gif';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

// import state definition and functions.
import { rG_setTopMenuPosition } from '../app/global-slice';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function Tool(props: {
  name: string;
  icon?: any;
  text: string;
  onClick: any;
  onMouseEnter?: any;
  onMouseLeave?: any;
  selected?: boolean;
  secondarySelected?: boolean;
  loading?: boolean;
  disabled?: boolean;
  fixedWidth?: boolean;
  alignLeft?: boolean;
  darkBackground?: boolean;
  largeText?: boolean;
  solidBackground?: boolean;
  updatePosition?: boolean;
}) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const dispatch = useAppDispatch();

  //	------------------------------------------------------------
  //
  //	Component code
  //
  //	------------------------------------------------------------

  return (
    <button
      ref={(element) => {
        //
        // update the position of the selected element, so we can set the position of the sub-elements.
        if (!element) {
          return;
        }

        if (props.selected === true && props.updatePosition === true) {
          dispatch(
            rG_setTopMenuPosition({
              leftUpper: element.getBoundingClientRect().left,
              widthUpper: element.getBoundingClientRect().width,
            }),
          );
        }
        //
      }}
      name={props.name}
      type="button"
      className="button-tabbed"
      data-selected={props.selected && props.disabled !== true ? 'T' : 'F'}
      data-secondary-selected={
        props.secondarySelected && props.disabled !== true ? 'T' : 'F'
      }
      data-dark-background={props.darkBackground ? 'T' : 'F'}
      onClick={props.disabled !== true ? props.onClick : undefined}
      onMouseEnter={
        props.disabled !== true && props.onMouseEnter !== undefined
          ? props.onMouseEnter
          : undefined
      }
      onMouseLeave={
        props.disabled !== true && props.onMouseLeave !== undefined
          ? props.onMouseLeave
          : undefined
      }
      data-large-text={props.largeText === true ? 'T' : 'F'}
      data-fixed-width={props.fixedWidth === true ? 'T' : 'F'}
      data-solid-background={props.solidBackground === true ? 'T' : 'F'}
    >
      <div className="tool-icon-container">
        <img src={props.icon} role="presentation" alt="" width="22" height="22" />
      </div>
      <div
        className="button-text-container"
        data-disabled={props.disabled === true ? 'T' : 'F'}
        data-dark-background={props.darkBackground ? 'T' : 'F'}
        data-large-text={props.largeText === true ? 'T' : 'F'}
      >
        {props.text}
        {props.loading === true ? (
          <img src={spinnerDark} role="presentation" alt="" width="18" height="18" />
        ) : (
          <></>
        )}
      </div>
    </button>
  );
  //
} // Tool
